import ApiService from "@/core/services/api.service";
import {GET_DETAIL_TOURNAMENT, GET_TOURNAMENT} from "@/core/services/store/tournament/tournament.module";
import {GET_LIST_BRANCH_BY_TICKET} from "@/core/services/store/task-management/task-management.module";
import {UPDATE_MARKING_ADMIN} from "@/core/services/store/marking/admin.module";

export const ADD_NEW_TUTOR = 'ADD_NEW_TUTOR';
export const GET_LIST_TUTOR = 'academic/admin/tutors/list'
export const GET_LIST_TUTOR_LEVEL = 'academic/tutors/study/levels'
export const DELETE_TUTOR = 'DELETE_TUTOR'
export const CREATE_OTHER_TASK = 'CREATE_OTHER_TASK'
export const GET_DETAIL_TUTOR = 'GET_DETAIL_TUTOR'
export const UPDATE_TUTOR = 'academic/admin/tutors'
export const GET_WEEKLY_SCHEDULE = 'GET_WEEKLY_SCHEDULE'
export const GET_WEEKLY_TASK = 'GET_WEEKLY_TASK'
export const PUT_WEEKLY_SCHEDULE = 'PUT_WEEKLY_SCHEDULE'
export const GET_FREE_ADMIN = 'GET_FREE_ADMIN'
export const GET_SLOT = 'GET_SLOT'
export const CREATE_SPECIAL_TUTOR = 'CREATE_SPECIAL_TUTOR'
export const GET_LESSONS = 'GET_LESSONS'
export const GET_SLOT_AFTER_OPENING = 'GET_SLOT_AFTER_OPENING'
export const POST_AFTER_OPENING = 'POST_AFTER_OPENING'
export const POST_BUFFER_CLASS_TUTORING = 'POST_BUFFER_CLASS_TUTORING'
export const GET_LIST_TASK = 'GET_LIST_TASK'
export const GET_LIST_LEVEL = 'GET_LIST_LEVEL'
export const GET_ALL_TUTOR = 'GET_ALL_TUTOR'
export const GET_TUTOR_DETAIL_TASK = 'GET_TUTOR_DETAIL_TASK'
export const DELETE_OTHER_TASK = 'DELETE_OTHER_TASK'
export const CANCEL_TUTOR_TASK = 'CANCEL_TUTOR_TASK'
export const UPDATE_OTHER_TASK = 'UPDATE_OTHER_TASK'
export const UPDATE_TUTOR_TASK = 'UPDATE_TUTOR_TASK'
export const CANCEL_DETAIL_TUTOR_TASK = 'CANCEL_DETAIL_TUTOR_TASK'
export const COMPLETE_DETAIL_TUTOR_TASK = 'COMPLETE_DETAIL_TUTOR_TASK'
export const MARK_JOINED_CLASS = 'MARK_JOINED_CLASS'
export const GET_PERSONAL_TASK = 'GET_PERSONAL_TASK'
export const GET_ALL_SHIFT = 'GET_ALL_SHIFT'
export const JOIN_CLASS = 'JOIN_CLASS'
export const GET_STUDENT_OF_TUTOR = 'GET_STUDENT_OF_TUTOR'
export const REASSIGN_TUTOR = 'REASSIGN_TUTOR'
export const EXPORT_TUTOR_TASK_MANAGEMENT = "academic/tutors/task/export"
export const POST_RETAKE_TUTORING = "POST_RETAKE_TUTORING";
export const VALIDATE_TUTOR_TASK_DATA = "VALIDATE_TUTOR_TASK_DATA";
export const IMPORT_TUTOR_TASK_DATA = "IMPORT_TUTOR_TASK_DATA";
export const GET_REPORT_TUTOR = "GET_REPORT_TUTOR";
export const GET_MAKEUP_VIDEO_REPORT = "GET_MAKEUP_VIDEO_REPORT";
export const EXPORT_MAKEUP_VIDEO_REPORT = "EXPORT_MAKEUP_VIDEO_REPORT";
export const COMPLETE_LESSON = "academic/tutors/task/tutor-completed-lesson"
export const GET_SUPPLEMENTARY_TUTOR_STUDENTS = 'GET_SUPPLEMENTARY_TUTOR_STUDENTS'
export const EXPORT_SUPPLEMENTARY_TUTOR_STUDENTS = 'academic/tutors/task/export-supplementary'
export const COMPLETE_SUPPLEMENTARY_TUTOR_ATTENDANCE = 'COMPLETE_SUPPLEMENTARY_TUTOR_ATTENDANCE'
export const SAVE_SUPPLEMENTARY_TUTOR_EVALUATION = 'SAVE_SUPPLEMENTARY_TUTOR_EVALUATION'
export const SAVE_SUPPLEMENT_TUTOR_REVIEW = "academic/tutors/task/tutor-reviewed-lesson"
export const GET_SUPPLEMENT_TUTOR_COMPETENCIES = "GET_SUPPLEMENT_TUTOR_COMPETENCIES"
export const POST_SUPPLEMENTARY_CLASS_TUTORING = "POST_SUPPLEMENTARY_CLASS_TUTORING"


const state = {};
const getters = {};
const mutations = {};
const actions = {
  [ADD_NEW_TUTOR](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/admin/tutors`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_LIST_TUTOR](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/admin/tutors/list`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [GET_LIST_TUTOR_LEVEL](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/study/levels`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [DELETE_TUTOR](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.delete("academic/admin/tutors", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [CREATE_OTHER_TASK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/other`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_DETAIL_TUTOR](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("academic/admin/tutors", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_TUTOR](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("academic/admin/tutors/" + payload.id, payload)
        .then(({ data }) => resolve(data))
        .catch((response) => reject(response));
    });
  },
  [GET_WEEKLY_SCHEDULE](context, { credentials, id }) {
    return new Promise((resolve, reject) => {
      ApiService.query(
        `academic/admin/tutors/${id}/daily-schedule`,
        credentials
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [GET_WEEKLY_TASK](context, { credentials, id }) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/admin/tutors/${id}/tasks/weekly`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [PUT_WEEKLY_SCHEDULE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put(
        `academic/admin/tutors/${payload.id}/daily-schedule`,
        payload.payload
      )
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [GET_FREE_ADMIN](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(
        `academic/admin/tutors/admin-profiles-by-range-date`,
        credentials
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [GET_SLOT](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/task/available-slots`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [CREATE_SPECIAL_TUTOR](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/special`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_LESSONS](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/task/get-lessons`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [GET_SLOT_AFTER_OPENING](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(
        `academic/tutors/task/post-opening/available-slots`,
        credentials
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [POST_AFTER_OPENING](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/post-opening`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [POST_BUFFER_CLASS_TUTORING](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/buffer-class`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_LIST_TASK](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/task/list`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [GET_LIST_LEVEL](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/study/levels`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [GET_SUPPLEMENT_TUTOR_COMPETENCIES](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/task/competencies`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [POST_SUPPLEMENTARY_CLASS_TUTORING](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/supplementary-class`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_ALL_TUTOR](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/admin/tutors/all`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [GET_TUTOR_DETAIL_TASK](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("academic/tutors/task", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DELETE_OTHER_TASK](context, id) {
    return new Promise((resolve) => {
      ApiService.delete("academic/tutors/task", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((response) => {
          console.log(response);
        });
    });
  },
  [CANCEL_TUTOR_TASK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/cancel/${payload.id}`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_OTHER_TASK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("academic/tutors/task/other/" + payload.id, payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [UPDATE_TUTOR_TASK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("academic/tutors/task/" + payload.id, payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [CANCEL_DETAIL_TUTOR_TASK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `academic/tutors/task/tutor-cancel/${payload.idTask}`,
        payload.formData
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [COMPLETE_DETAIL_TUTOR_TASK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `academic/tutors/task/tutor-completed/${payload.idTask}`,
        payload.formData
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [MARK_JOINED_CLASS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `academic/tutors/task/${payload.idTask}/join-class`,
        payload
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_PERSONAL_TASK](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/task/personal`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [GET_ALL_SHIFT](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/admin/tutors/shifts/all`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [JOIN_CLASS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/${payload.id}/join-class`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_STUDENT_OF_TUTOR](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/study/students`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [REASSIGN_TUTOR](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put(
        `academic/admin/tutors/${payload.id}/reassign`,
        payload.data
      )
        .then(({ data }) => resolve(data))
        .catch((response) => reject(response));
    });
  },
  [EXPORT_TUTOR_TASK_MANAGEMENT](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(EXPORT_TUTOR_TASK_MANAGEMENT, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [POST_RETAKE_TUTORING](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/retake-class`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [COMPLETE_LESSON](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${COMPLETE_LESSON}/${payload.idTask}`,
          payload.formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
    });
  },
  [GET_SUPPLEMENTARY_TUTOR_STUDENTS](context, idTask) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/task/${idTask}/supplementary/students`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [EXPORT_SUPPLEMENTARY_TUTOR_STUDENTS](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(EXPORT_SUPPLEMENTARY_TUTOR_STUDENTS, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [COMPLETE_SUPPLEMENTARY_TUTOR_ATTENDANCE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `academic/tutors/task/${payload.idTask}/supplementary/attendance`,
        payload.formData
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [SAVE_SUPPLEMENTARY_TUTOR_EVALUATION](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `academic/tutors/task/${payload.idTask}/supplementary/evaluate`,
        payload.data
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [SAVE_SUPPLEMENT_TUTOR_REVIEW](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${SAVE_SUPPLEMENT_TUTOR_REVIEW}/${payload.idTask}`, payload.data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [VALIDATE_TUTOR_TASK_DATA](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/validate-import`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [IMPORT_TUTOR_TASK_DATA](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`academic/tutors/task/import`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_REPORT_TUTOR](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(
        `academic/tutors/task/reports/tutor-performance`,
        credentials
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ res }) => {
          reject(res);
        });
    });
  },
  [GET_MAKEUP_VIDEO_REPORT](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`academic/tutors/task/reports/makeup-videos`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [EXPORT_MAKEUP_VIDEO_REPORT](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.query(`classrooms/error-export-video`, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
};
export default {
    state,
    actions,
    mutations,
    getters
};
